import ApiInfo from './ApiInfo.js'

class QuKanSearchApiInfo extends ApiInfo {
    constructor({
        path,
        type = 'get',
        timeout = 5000,
        headers,
        project = 'search', // || qukan,
        author = '未定义'
    }) {
        super({
            path,
            type,
            timeout,
            headers,
            project,
            author
        })
    }
}

export default {
    innersearch: new QuKanSearchApiInfo({
        path: '/search/algorithm/searchDistributionTag',
        type: 'get',
        author: '魏文平'
    })
}



// WEBPACK FOOTER //
// ./src/core/Apis/Search.js